export default "__VITE_ASSET__bKoqOUmW__"